module.exports = __webpack_public_path__ + "static/12-8afb9d9a8852e71654fad1638eb2ffec.png";